import { render, staticRenderFns } from "./HolidaySettingsPage.vue?vue&type=template&id=382e815f&scoped=true&"
import script from "./HolidaySettingsPage.vue?vue&type=script&lang=js&"
export * from "./HolidaySettingsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382e815f",
  null
  
)

export default component.exports